import {STATUS_SERVICE} from '../../constants/app/services';
import INSPECTION_DETAIL_ACTIONS from '../../constants/actions/inspection';
import '../../styles/inspection.css';
import TransformInspection from '../../lib/utils/transforms/inspection'

const defaultState = {
    enabledObservation: false,
    inspection: {
        damageCommentDB: '',
        damageComment: '',
        generalCommentDB: '',
        generalComment: '',
        detail: {},
        customer: {},
        inspection: {},
        states: [],
        state: {},
        imagesVehicle: [],
        policy: {},
        accesories: [],
        damages: [],
        picturesObserveds: [],
    },
    status: {
        all: STATUS_SERVICE.INITIAL,
        customer: STATUS_SERVICE.INITIAL,
        inspection: STATUS_SERVICE.INITIAL,
        state: STATUS_SERVICE.INITIAL,
        imagesVehicle: STATUS_SERVICE.INITIAL,
        policy: STATUS_SERVICE.INITIAL,
        accesories: STATUS_SERVICE.INITIAL,
        damages: STATUS_SERVICE.INITIAL,
        approved: STATUS_SERVICE.INITIAL,
        returned: STATUS_SERVICE.INITIAL,
        derived: STATUS_SERVICE.INITIAL,
        rejected: STATUS_SERVICE.INITIAL,
        presencial: STATUS_SERVICE.INITIAL,
        reportInspections: STATUS_SERVICE.INITIAL
    }
};

const InspectionDetailReducer = (state = defaultState, {type, payload, evt}) => {
    switch (type) {
        case INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL: {
            return {
                ...defaultState,
                status: {
                    ...state.status,
                    all: STATUS_SERVICE.INPROGRESS
                }
            }
        }
        case INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_OK: {
            return {
                ...state,
                status: {
                    ...state.status,
                    all: STATUS_SERVICE.SUCCESS
                }
            }
        }
        case INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_OK: {
            let inspection = payload;
            if (!inspection.damageComment) inspection.damageComment = '';
            inspection.damageCommentDB = inspection.damageComment;

            if (!inspection.generalComment) inspection.generalComment = '';
            inspection.generalCommentDB = inspection.generalComment;
            return {
                ...state,
                inspection: payload
            }
        }
        case INSPECTION_DETAIL_ACTIONS.LOAD_CUSTOMER_OK: {
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    customer: payload
                },
                status: {
                    ...state.status,
                    customer: STATUS_SERVICE.SUCCESS
                }
            }
        }
        case INSPECTION_DETAIL_ACTIONS.LOAD_CUSTOMER_ERROR: {
            return {
                ...state,
                status: {
                    ...state.status,
                    customer: STATUS_SERVICE.ERROR
                }
            }
        }
        case INSPECTION_DETAIL_ACTIONS.LOAD_STATE_OK:
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    states: payload,
                    state: payload[0],
                },
                status: {
                    ...state.status,
                    state: STATUS_SERVICE.SUCCESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_STATE_ERROR:
            return {
                ...state,
                status: {
                    ...state.status,
                    state: STATUS_SERVICE.ERROR
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_PICTURES_OK:
            let pictures = TransformInspection.getArrayPictures(payload);
            let picturesFiltered = [];
            pictures.forEach((pic) => {
                if (pic.pictureCode === 'UP' && !pic.files.length) {
                    null;
                } else {
                    return picturesFiltered.push(pic)
                }
            });
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    pictures: picturesFiltered
                },
                status: {
                    ...state.status,
                    pictures: STATUS_SERVICE.SUCCESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_PICTURES_OBSERVEDS_OK:
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    picturesObserveds: payload
                },
                status: {
                    ...state.status,
                    picturesObserveds: STATUS_SERVICE.SUCCESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_DAMAGES_OK:
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    damages: payload
                },
                status: {
                    ...state.status,
                    damages: STATUS_SERVICE.SUCCESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_POLICY_OK:
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    policy: payload
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_ACCESORIES_OK: {
            // let accessories = TransformInspection.getArrayAccessories(payload);
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    accessories: payload
                },
                status: {
                    ...state.status,
                    accesories: STATUS_SERVICE.SUCCESS
                }
            }
        }
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RESET_VALUES:
            return {
                ...state,
                commentSaved: STATUS_SERVICE.INITIAL,
            };

        // In Person Inspection
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_PRESENCIAL:
            return {
                ...state,
                status: {
                    ...state.status,
                    presencial: STATUS_SERVICE.INPROGRESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_PRESENCIAL_OK:
            return {
                ...state,
                status: {
                    ...state.status,
                    presencial: STATUS_SERVICE.SUCCESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_PRESENCIAL_ERROR:
            return {
                ...state,
                status: {
                    ...state.status,
                    presencial: STATUS_SERVICE.ERROR
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_PRESENCIAL_RESET:
            return {
                ...state,
                status: {
                    ...state.status,
                    presencial: STATUS_SERVICE.INITIAL
                }
            };

        // Approve Inspection
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_APPROVED:
            return {
                ...state,
                status: {
                    ...state.status,
                    approved: STATUS_SERVICE.INPROGRESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_APPROVED_OK:
            return {
                ...state,
                status: {
                    ...state.status,
                    approved: STATUS_SERVICE.SUCCESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_APPROVED_ERROR:
            return {
                ...state,
                status: {
                    ...state.status,
                    approved: STATUS_SERVICE.ERROR
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_APPROVED_RESET:
            return {
                ...state,
                status: {
                    ...state.status,
                    approved: STATUS_SERVICE.INITIAL
                }
            };

        // Reject Inspection
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REJECTED:
            return {
                ...state,
                status: {
                    ...state.status,
                    rejected: STATUS_SERVICE.INPROGRESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REJECTED_OK:
            return {
                ...state,
                status: {
                    ...state.status,
                    rejected: STATUS_SERVICE.SUCCESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REJECTED_ERROR:
            return {
                ...state,
                status: {
                    ...state.status,
                    rejected: STATUS_SERVICE.ERROR
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REJECTED_RESET:
            return {
                ...state,
                status: {
                    ...state.status,
                    rejected: STATUS_SERVICE.INITIAL
                }
            };

        // Derive Inspection
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_DERIVE:
            return {
                ...state,
                status: {
                    ...state.status,
                    derived: STATUS_SERVICE.INPROGRESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_DERIVE_OK:
            let inspection = {...state.inspection};
            return {
                ...state,
                status: {
                    ...state.status,
                    derived: STATUS_SERVICE.SUCCESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_DERIVE_ERROR:
            return {
                ...state,
                status: {
                    ...state.status,
                    derived: STATUS_SERVICE.ERROR
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_DERIVE_RESET:
            return {
                ...state,
                status: {
                    ...state.status,
                    derived: STATUS_SERVICE.INITIAL
                }
            };

        // Return Inspection
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN:
            return {
                ...state,
                status: {
                    ...state.status,
                    returned: STATUS_SERVICE.INPROGRESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_OK:
            return {
                ...state,
                status: {
                    ...state.status,
                    returned: STATUS_SERVICE.SUCCESS
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_ERROR:
            return {
                ...state,
                status: {
                    ...state.status,
                    returned: STATUS_SERVICE.ERROR
                }
            };
        case INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_RESET:
            return {
                ...state,
                status: {
                    ...state.status,
                    returned: STATUS_SERVICE.INITIAL
                }
            };

        // Damage Comment
        case INSPECTION_DETAIL_ACTIONS.CHANGE_COMMENT_DAMAGES: {
            let isEnter = false;
            if (payload.indexOf('\n') !== -1) {
                return {
                    ...state,
                    inspection: {
                        ...state.inspection,
                        damageComment: payload.slice(0, -1)
                    }
                }
            } else {
                return {
                    ...state,
                    inspection: {
                        ...state.inspection,
                        damageComment: payload
                    }
                }
            }
        }

        // comentario general fotos generales
        case INSPECTION_DETAIL_ACTIONS.CHANGE_COMMENT_PICTURES:
            if (payload.indexOf('\n') !== -1) {
                return {
                    ...state,
                    inspection: {
                        ...state.inspection,
                        generalComment: payload.slice(0, -1)
                    }
                }
            } else {
                return {
                    ...state,
                    inspection: {
                        ...state.inspection,
                        generalComment: payload
                    }
                }
            }
        case INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_DAMAGES_OK: {
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    damageCommentDB: state.inspection.damageComment
                },
            }
        }

        // guardar comentario en fotos generales
        case INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_PICTURES_OK: {
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    generalCommentDB: state.inspection.generalComment
                },
            }
        }
        case INSPECTION_DETAIL_ACTIONS.ADD_PICTURE_OBSERVATION: {
            let pictures = [...state.inspection.pictures];
            pictures[payload.index].selected = true;
            pictures[payload.index].observationCode = payload.observation;
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    pictures
                }
            }
        }
        case INSPECTION_DETAIL_ACTIONS.REMOVE_PICTURE_OBSERVATION: {
            let pictures = [...state.inspection.pictures];
            pictures[payload.index].selected = false;
            pictures[payload.index].observationCode = null;
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    pictures
                }
            }
        }
        case INSPECTION_DETAIL_ACTIONS.ADD_ACCESSORY_OBSERVATION: {
            let accessories = [...state.inspection.accessories];
            accessories[payload.index].selected = true;
            accessories[payload.index].observationCode = payload.observation;
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    accessories
                }
            }
        }
        case INSPECTION_DETAIL_ACTIONS.REMOVE_ACCESSORY_OBSERVATION: {
            let accessories = [...state.inspection.accessories];
            accessories[payload.index].selected = false;
            accessories[payload.index].observationCode = null;
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    accessories
                }
            }
        }
        case INSPECTION_DETAIL_ACTIONS.ADD_DAMAGE_OBSERVATION: {
            let damages = [...state.inspection.damages];
            damages[payload.index].selected = true;
            damages[payload.index].observationCode = payload.observation;
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    damages
                }
            }
        }
        case INSPECTION_DETAIL_ACTIONS.REMOVE_DAMAGE_OBSERVATION: {
            let damages = [...state.inspection.damages];
            damages[payload.index].selected = false;
            damages[payload.index].observationCode = null;
            return {
                ...state,
                inspection: {
                    ...state.inspection,
                    damages
                }
            }
        }
        case INSPECTION_DETAIL_ACTIONS.VALIDATE_BUTTON_OBSERVATION_OK: {
            return {
                ...state,
                enabledObservation: payload
            }
        }

        default:
            return {
                ...state
            }
    }
};

export default InspectionDetailReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/inspection.js